'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticModule = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _verify = require('helpers/verify');

var _ExploreMapV = require('components/CmsPage/modules/Experimental/ExploreMap/ExploreMapV1');

var _FreeTrialSignupV = require('components/CmsPage/modules/Experimental/FreeTrialSignup/FreeTrialSignupV2');

var _FreeTrialSignupV2 = require('components/CmsPage/modules/Experimental/FreeTrialSignup/FreeTrialSignupV3');

var _HowItWorksV = require('components/CmsPage/modules/Experimental/HowItWorks/HowItWorksV1');

var _LocationSelector = require('components/CmsPage/modules/LocationSelector/LocationSelector');

var _WhyClassPassV = require('components/CmsPage/modules/Experimental/WhyClassPass/WhyClassPassV1');

var _VIPKidPlanCards = require('components/CmsPage/modules/Experimental/CustomPlanCards/VIPKidPlanCards');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STATIC_MODULE_RENDERER_BY_NAME = {
  explore_map_v1: function explore_map_v1() {
    return _react2.default.createElement(_ExploreMapV.ExploreMapV1, null);
  },
  free_trial_signup_v2: function free_trial_signup_v2() {
    return _react2.default.createElement(_FreeTrialSignupV.FreeTrialSignupV2, null);
  },
  free_trial_signup_v3: function free_trial_signup_v3() {
    return _react2.default.createElement(_FreeTrialSignupV2.FreeTrialSignupV3, null);
  },
  how_it_works_v1: function how_it_works_v1() {
    return _react2.default.createElement(_HowItWorksV.HowItWorksV1, null);
  },
  location_selector: function location_selector() {
    return _react2.default.createElement(_LocationSelector.LocationSelector, null);
  },
  why_classpass_v1: function why_classpass_v1() {
    return _react2.default.createElement(_WhyClassPassV.WhyClassPassV1, null);
  },
  vipkids_plan_cards: function vipkids_plan_cards() {
    return _react2.default.createElement(_VIPKidPlanCards.VIPKidPlanCards, null);
  }
};

var StaticModule = exports.StaticModule = function StaticModule(_ref) {
  var moduleName = _ref.moduleName,
      _ref$moduleRendererBy = _ref.moduleRendererByName,
      moduleRendererByName = _ref$moduleRendererBy === undefined ? STATIC_MODULE_RENDERER_BY_NAME : _ref$moduleRendererBy;

  var moduleRenderer = moduleRendererByName[moduleName];

  if ((0, _verify.isAbsent)(moduleRenderer)) {
    // eslint-disable-next-line no-console
    console.error('Module [' + moduleName + '] is not registered');

    return null;
  }

  return moduleRenderer();
};

StaticModule.propTypes = {
  moduleName: _propTypes2.default.string.isRequired
};